import type { TechFormValidationSummaryProps } from "../models/tech-form-validation-ui.models";
import { TECH_FORM_VALIDATION_CONFIG } from "../models/tech-form-validation.constants";

export function TechFormValidationSummary({ issues, onSelect }: TechFormValidationSummaryProps) {
  if (!issues.length) return null;
  return (
    <section aria-label="Fields needing attention" className="m-4 rounded border border-red-600 p-3 text-sm">
      <p className="font-semibold">Complete or correct these fields before continuing ({issues.length}).</p>
      <button type="button" className="mt-2 underline" onClick={() => onSelect(issues[0])}>
        Go to first field: {issues[0].label}
      </button>
      <details className="mt-2">
        <summary className="cursor-pointer">Show all fields needing attention</summary>
        <ul className="mt-2 list-inside list-disc">
          {issues.map((issue) => (
            <li key={issue.section + ":" + issue.key}>
              <button type="button" className="text-left underline" onClick={() => onSelect(issue)}>
                {TECH_FORM_VALIDATION_CONFIG.sectionTitles[issue.section]} — {issue.label}: {issue.message}
              </button>
            </li>
          ))}
        </ul>
      </details>
    </section>
  );
}
